import styled from 'styled-components';
import { EmptyStateFind } from 'ui/illustrations';
import { EmptyState } from 'ui/emptyState';
import { spacing } from 'ui/theme';

export const ERROR_PAGE_TEXT = {
  TITLE: 'No subscription channels found',
  SUBTITLE: 'Looks like you are a bit off track, try going home.',
  ERROR_ID: 'error-channels-page',
};

const Container = styled.div`
  padding-top: ${spacing.double};
  padding-bottom: ${spacing.double};
`;

export const ErrorPage = () => (
  <Container data-testid={ERROR_PAGE_TEXT.ERROR_ID}>
    <EmptyState
      Illustration={EmptyStateFind}
      title={ERROR_PAGE_TEXT.TITLE}
      subtitle={ERROR_PAGE_TEXT.SUBTITLE}
    />
  </Container>
);
